"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddressTransport = void 0;
const address_transport_1 = require("../../common/address-transport");
/**
 * @deprecated - Use common/address-transport
 */
exports.AddressTransport = address_transport_1.AddressTransport;
//# sourceMappingURL=address-transport.js.map